import { t, obtenerTexto, obtenerDescBisel } from "../labelHelpers";
import { getPurpleGrid } from "../styles";
import type { PdfContext } from "../types";

// Segundo bloque: tabla con forma, calibre, puente, altura boxing, DNP,
// altura de montaje y tipo de bisel; debajo el código de barras del pedido.
export function buildFormaSection(ctx: PdfContext) {
  const lg = ctx.labelGetters;
  return {
                columns: [
                  {
                    width: "30%",
                    stack: [
                      {
                        table: {
                          widths: ["*", "*", "*"],
                          body: [
                            [
                              { text: t("forma"), border: [false, false, false, false] },
                              {
                                text: (() => {
                                  const origenDatos = ctx.pedido?.oClaseBAPI?.CABFRM?.ORIGEN_DATOS || ctx.store?.state?.indo?.pedido?.oClaseBAPI?.listCABFRM?.clsZES_CAB_FORMA?.[0]?.ORIGEN_DATOS || "";
                                  return obtenerTexto(origenDatos) || lg.getFormaLenteLabel() || "";
                                })(),
                                style: "th",
                                border: [true, true, true, true],
                                colSpan: 2,
                              },
                              {},
                            ],
                            [
                              { text: " ", border: [false, false, false, false], fontSize: 1 },
                              { text: "", border: [false, false, false, false], fontSize: 1 },
                              { text: "", border: [false, false, false, false], fontSize: 1 },
                            ],
                            [
                              { text: "", border: [false, false, false, false] },
                              { text: t("od"), style: "th", border: [false, false, false, false] },
                              { text: t("oi"), style: "th", border: [false, false, false, false] },
                            ],
                            [
                              { text: " ", border: [false, false, false, false], fontSize: 1 },
                              { text: "", border: [false, false, false, false], fontSize: 1 },
                              { text: "", border: [false, false, false, false], fontSize: 1 },
                            ],
                            [
                              { text: t("calibre"), border: [false, false, false, false] },
                              {
                                text: `${ctx.pedido?.oClaseBAPI?.CABFRM?.CALIBRE ?? ctx.store?.state?.indo?.pedido?.oClaseBAPI?.listCABFRM?.clsZES_CAB_FORMA[0]?.CALIBRE ?? ""}`,
                                style: "th",
                                border: [true, true, true, true],
                                colSpan: 2,
                              },
                              {} /*. ctx.pedido?.oClaseBAPI?.CABFRM?.CALIBRE?? '' lenses.calibre */,
                            ],
                            [
                              { text: " ", border: [false, false, false, false], fontSize: 1 },
                              { text: "", border: [false, false, false, false], fontSize: 1 },
                              { text: "", border: [false, false, false, false], fontSize: 1 },
                            ],
                            [
                              { text: t("puente"), border: [false, false, false, false] },
                              {
                                text: `${ctx.pedido?.oClaseBAPI?.CABFRM?.PUENTE ?? ctx.store?.state?.indo?.pedido?.oClaseBAPI?.listCABFRM?.clsZES_CAB_FORMA[0]?.PUENTE ?? ""}`,
                                style: "th",
                                border: [true, true, true, true],
                                colSpan: 2,
                              },
                              {} /*. ctx.pedido?.oClaseBAPI?.CABFRM?.PUENTE?? '' lenses.puente  */,
                            ],
                            [
                              { text: " ", border: [false, false, false, false], fontSize: 1 },
                              { text: "", border: [false, false, false, false], fontSize: 1 },
                              { text: "", border: [false, false, false, false], fontSize: 1 },
                            ],
                            [
                              { text: t("altura_boxing"), border: [false, false, false, false] },
                              {
                                text: `${ctx.pedido?.oClaseBAPI?.CABFRM?.ALT_BOX ?? ctx.store?.state?.indo?.pedido?.oClaseBAPI?.listCABFRM?.clsZES_CAB_FORMA[0]?.ALT_BOX ?? ""}`,
                                style: "th",
                                border: [true, true, true, true],
                                colSpan: 2,
                              },
                              {} /*. ctx.pedido?.oClaseBAPI?.CABFRM?.ALT_BOX?? '' lenses.altura_boxing*/,
                            ],
                            [
                              { text: " ", border: [false, false, false, false], fontSize: 1 },
                              { text: "", border: [false, false, false, false], fontSize: 1 },
                              { text: "", border: [false, false, false, false], fontSize: 1 },
                            ],
                            [
                              { text: t("dnp"), border: [false, false, false, false] },
                              {
                                text: `${ctx.pedido?.oClaseBAPI?.CABFRM?.DIST_NP_OD ?? ctx.store?.state?.indo?.pedido?.oClaseBAPI?.listCABFRM?.clsZES_CAB_FORMA[0]?.DIST_NP_OD ?? ""}`,
                                style: "th",
                                border: [true, true, true, true],
                              },
                              {
                                text: `${ctx.pedido?.oClaseBAPI?.CABFRM?.DIST_NP_OI ?? ctx.store?.state?.indo?.pedido?.oClaseBAPI?.listCABFRM?.clsZES_CAB_FORMA[0]?.DIST_NP_OI ?? ""}`,
                                style: "th",
                                border: [true, true, true, true],
                              },
                              /*. ctx.pedido?.oClaseBAPI?.CABFRM?.DIST_NP_OD?? lenses.od.dnp'' // ctx.pedido?.oClaseBAPI?.CABFRM?.DIST_NP_OI?? '' lenses.oi.dnp */
                            ],
                            [
                              { text: " ", border: [false, false, false, false], fontSize: 1 },
                              { text: "", border: [false, false, false, false], fontSize: 1 },
                              { text: "", border: [false, false, false, false], fontSize: 1 },
                            ],
                            [
                              { text: t("altura_montaje"), border: [false, false, false, false],noWrap: true },
                              {
                                text: `${ctx.pedido?.oClaseBAPI?.CABFRM?.ALTURA_OD ?? ctx.store?.state?.indo?.pedido?.oClaseBAPI?.listCABFRM?.clsZES_CAB_FORMA[0]?.ALTURA_OD ?? ""}`,
                                style: "th",
                                border: [true, true, true, true],
                              },
                              {
                                text: `${ctx.pedido?.oClaseBAPI?.CABFRM?.ALTURA_OI ?? ctx.store?.state?.indo?.pedido?.oClaseBAPI?.listCABFRM?.clsZES_CAB_FORMA[0]?.ALTURA_OI ?? ""}`,
                                style: "th",
                                border: [true, true, true, true],
                              },
                              
                            ],
                            [
                              { text: " ", border: [false, false, false, false], fontSize: 1 },
                              { text: "", border: [false, false, false, false], fontSize: 1 },
                              { text: "", border: [false, false, false, false], fontSize: 1 },
                            ],
                            [
                              { text: t("tipo_bisel"), border: [false, false, false, false] },
                              {
                                text:
                                  obtenerDescBisel(
                                    // Mismo doble escalón que el resto de la tabla: el
                                    // accesor `CABFRM` solo llega del servidor, el
                                    // formulario escribe en `listCABFRM`.
                                    ctx.pedido?.oClaseBAPI?.CABFRM?.BISEL ??
                                      ctx.pedido?.oClaseBAPI?.listCABFRM?.clsZES_CAB_FORMA?.[0]?.BISEL ??
                                      ctx.store?.state?.indo?.pedido?.oClaseBAPI?.listCABFRM
                                        ?.clsZES_CAB_FORMA?.[0]?.BISEL,
                                  ) ?? "",
                                style: "th",
                                border: [true, true, true, true],
                                colSpan: 2,
                              },
                              {},
                            ],
                          ],
                        },
                        layout: getPurpleGrid(),
                      },
                      {
                        columns: [
                          {
                            image: ctx.generarCodigoBarras(
                              `${ctx.pedido?.oClaseBAPI?.CABOUT?.VBELN ?? ""}`
                            ),
                            height: 40,
                            width: 110,
                            margin: [10, 30, 0, 10],
                          },
                        ],
                      },
                    ],
                  },
                 
                ],
    columnGap: 70,
  };
}
